module.exports = __webpack_public_path__ + "static/media/MyProfileIcon.8ac204bb.svg";